// A股-瑞交所GDR比价
import { Observer } from "mobx-react-lite"
import React from "react"
import { QuestionIcon } from "../../shared/icon"
import { PageType } from "../../shared/pagetype"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"
import { store } from "./store"

export function ACHPrice(props: { pagetype: PageType }) {

  const clickACH = (data:any)=>{
    window.location.href = `/quote/stock/${data.f748}.${data.f747}.html`;
  }

  return (
    <Observer>
      {() => (
        <>
          {store.StockDetail && store.StockDetail.f747 && store.StockDetail.f747 != '-' && (props.pagetype == PageType.沪深A股) && (
            <div className="ah-notice">
              <div className="ah-container" onClick={()=>clickACH(store.StockDetail)}>
                <p>
                  瑞士GDR报价：
                  {single_quote[quote_item_name.GDR报价](store.StockDetail).element}
                </p>
                <p>
                  <QuestionIcon/>
                  (A/GDR)比价={single_quote[quote_item_name["(A/GDR)比价"]](store.StockDetail).element}
                  <i className="arrow-right-new"></i>
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </Observer>
  )
}
